import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../helpers/axiosInstance";

const initialState = {
    schemes: [],
    loading: false,
    error: null,
};

export const getSchemesList = createAsyncThunk(
    "schemes-list",
    async (user) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const base = url?.acsbackofficemanagement;
            const endpointpath = endpoint?.acsbackofficemanagement?.getallschemes;

            const apiURL = base + endpointpath;

            const response = await axiosInstance.get(apiURL);
            return response?.data;
        } catch (error) {
            throw error.response;
        }
    }
);

const schemesListSlice = createSlice({
    name: "schemes list",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getSchemesList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getSchemesList.fulfilled, (state, action) => {
                state.loading = false;
                state.schemes = action?.payload?.data ? action?.payload?.data?.filter(e => e.isActive) : [];
            })
            .addCase(getSchemesList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    },
});

export default schemesListSlice.reducer;